import * as defaultImport from "@splunk/react-icons/Cross";
export * from "@splunk/react-icons/Cross";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
